
import { Component, computed, inject, input } from '@angular/core'

import { Store } from '@ngrx/store'

import { AiDocumentContentType, ChatMessage } from '@flowx/designer/modules/ai/types/ai.types'

import { resetInputFileValueFromEvent } from '../../../../common/ai.utils'
import { ConversationActions } from '../../../../conversation/conversation.actions'
import { ConversationSelectors } from '../../../../conversation/conversation.selectors'

@Component({
  selector: 'flx-ai-msg-file-actions',
  imports: [],
  templateUrl: './ai-msg-file-actions.component.html',
  styleUrl: './ai-msg-file-actions.component.scss',
})
export class AiMsgFileActionsComponent {
  #store = inject(Store)

  msgActions = input<ChatMessage['actions']>()

  isUploadDisabled = this.#store.selectSignal(ConversationSelectors.isUploadDisabled)

  showImageUploadAction = computed(() => this.msgActions()?.imageUpload)
  allowedImageFileTypes = this.#store.selectSignal(ConversationSelectors.allowedImageFileTypes)
  isMultipleImageUploadAllowed = this.#store.selectSignal(
    ConversationSelectors.isMultipleImageUploadAllowed
  )

  showBpmnUploadAction = computed(() => this.msgActions()?.bpmnUpload)
  allowedBpmnFileTypes = this.#store.selectSignal(ConversationSelectors.allowedBpmnFileTypes)

  showFromDocumentsAction = computed(() => this.msgActions()?.checkDocumentContext)

  showDocumentUploadAction = computed(() => this.msgActions()?.documentUpload)
  allowedDocumentFileTypes = this.#store.selectSignal(
    ConversationSelectors.allowedDocumentFileTypes
  )
  isMultipleDocumentUploadAllowed = this.#store.selectSignal(
    ConversationSelectors.isMultipleDocumentUploadAllowed
  )

  checkContextDocuments(): void {
    this.#store.dispatch(
      ConversationActions.documentContextOpened({
        resourceType: AiDocumentContentType.BUSINESS_PROCESS,
        useInCurrentThread: true,
      })
    )
  }

  onFileSelected(event: Event): void {
    const files = Array.from((event.target as HTMLInputElement).files ?? [])
    this.#store.dispatch(ConversationActions.fileSelectedFromMessage({ files }))
    resetInputFileValueFromEvent(event)
  }
}
